import React from 'react';
import { Breadcrumbs, CellText, ChevronRight, Table } from '@opendate-app/setlist';
import CrmPageLayout from '../../shared/components/CrmPageLayout';

function CrmSettingsPage({ team, canManageLabels = false, canManageDonorFeatures = false }) {
  const teamId = team && team.id;

  const generalSettingsSections = [
    canManageLabels && {
      key: 'labels',
      title: 'Labels',
      description: 'Choose what your team calls the people, organizations and deals in your CRM.',
      iconClass: 'fal fa-pen',
      href: teamId ? `/teams/${teamId}/crm_labels` : null,
    },
    {
      key: 'contact-types',
      title: 'Contact Types',
      description: 'Choose the types you can give a contact, like Major Donor or Board Member.',
      iconClass: 'fal fa-id-badge',
      href: teamId ? `/teams/${teamId}/contact_types` : null,
    },
    canManageDonorFeatures && {
      key: 'donor-features',
      title: 'Donor Features',
      description: 'Turn soft credits, deals and volunteers on or off for your team.',
      iconClass: 'fal fa-sliders-h',
      href: teamId ? `/teams/${teamId}/crm_donor_features` : null,
    },
    {
      key: 'objects',
      title: 'Objects',
      description: 'Manage the core objects used in your Opendate CRM.',
      iconClass: 'fal fa-layer-group',
      href: teamId ? `/teams/${teamId}/crm-objects` : null,
    },
    {
      key: 'tags',
      title: 'Tags',
      description: 'Rename, delete, and merge tags across your CRM.',
      iconClass: 'fal fa-tags',
      href: teamId ? `/teams/${teamId}/crm-tags` : null,
    },
  ].filter(Boolean);

  const columns = [
    {
      key: 'setting',
      header: 'Setting',
      primary: true,
      render: (section) => (
        <div className="d-flex align-items-center" style={{ gap: 12 }}>
          <span
            className="d-inline-flex align-items-center justify-content-center rounded-circle"
            style={{ width: 32, height: 32, minWidth: 32, background: 'var(--sl-bg-secondary)', color: 'var(--sl-text-tertiary)' }}
          >
            <i className={section.iconClass} aria-hidden="true" />
          </span>
          <CellText
            primary={<a href={section.href} style={{ color: 'var(--sl-text-primary)', fontWeight: 600 }}>{section.title}</a>}
            supporting={section.description}
          />
        </div>
      ),
    },
    {
      key: 'navigate',
      header: <span className="sr-only">Open</span>,
      align: 'right',
      width: '1%',
      render: (section) => (
        <a href={section.href} aria-label={`Open ${section.title}`} style={{ color: 'var(--sl-text-tertiary)' }}>
          <ChevronRight width={20} height={20} aria-hidden="true" />
        </a>
      ),
    },
  ];

  return (
    <CrmPageLayout
      team={team}
      activeSidebarKey="settings"
      mainTopMargin={32}
      breadcrumb={<Breadcrumbs items={[{ label: 'Settings' }]} />}
      title="CRM Settings"
      subtitle="Manage the settings and configurations for your Opendate CRM."
    >
      <div className="card">
        <div className="card-body p-0">
          <Table columns={columns} data={generalSettingsSections} getRowKey={(section) => section.key} />
        </div>
      </div>
    </CrmPageLayout>
  );
}

export default CrmSettingsPage;
